import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Container, Heading, Text, Spinner, Flex, Icon, useColorModeValue } from '@chakra-ui/react';
import { FiCheckCircle, FiXCircle } from 'react-icons/fi';
import { API } from '../utils/apiBase';

export default function Unsubscribe() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');
  
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');

  const bg = useColorModeValue('white', 'bg.card');
  const textColor = useColorModeValue('gray.800', 'text.default');
  const mutedColor = useColorModeValue('gray.600', 'text.muted');

  useEffect(() => {
    if (!email) {
      setStatus('error');
      setMessage('No se proporcionó ningún correo.');
      return;
    }

    const unsubscribe = async () => {
      try {
        const res = await fetch(`${API}/subscribers/unsubscribe?email=${encodeURIComponent(email)}`);
        const data = await res.json();
        if (res.ok && data.ok) {
          setStatus('success');
          setMessage(data.message || 'Te has dado de baja exitosamente.');
        } else {
          throw new Error(data.error || 'Error al procesar la solicitud.');
        }
      } catch (e) {
        setStatus('error');
        setMessage(e.message);
      }
    };

    unsubscribe();
  }, [email]);

  return (
    <Box bg="bg.default" flex="1" py={20}>
      <Container maxW="md">
        <Box bg={bg} p={8} borderRadius="xl" boxShadow="sm" textAlign="center" border="1px solid" borderColor="border.default">
          {status === 'loading' && (
            <Flex direction="column" align="center" justify="center">
              <Spinner size="xl" color="accent.500" mb={4} />
              <Heading size="md" color={textColor}>Procesando solicitud...</Heading>
              <Text color={mutedColor} mt={2}>Por favor espera un momento.</Text>
            </Flex>
          )}

          {status === 'success' && (
            <Flex direction="column" align="center" justify="center">
              <Icon as={FiCheckCircle} boxSize={16} color="green.500" mb={4} />
              <Heading size="md" color={textColor}>¡Baja Exitosa!</Heading>
              <Text color={mutedColor} mt={2}>{message}</Text>
              <Text color={mutedColor} mt={4} fontSize="sm">
                Ya no recibirás correos semanales en <strong>{email}</strong>.
              </Text>
            </Flex>
          )}

          {status === 'error' && (
            <Flex direction="column" align="center" justify="center">
              <Icon as={FiXCircle} boxSize={16} color="red.500" mb={4} />
              <Heading size="md" color={textColor}>Ocurrió un error</Heading>
              <Text color={mutedColor} mt={2}>{message}</Text>
            </Flex>
          )}
        </Box>
      </Container>
    </Box>
  );
}
